import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import EditIcon from '@material-ui/icons/Edit'
import { Chip } from '@material-ui/core'
import { Link } from 'react-router-dom'

import CampaignsIcon from 'Assets/Images/icons/campaigns'
import { PATHS } from 'Config/Routing/paths'
import { CampaignPageWrapper } from 'Components/Campaigns/Page/CampaignPageWrapper/index'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { LogoRound } from 'Components/LogoRound'
import { PageTitle } from 'Components/PageTitle'
import StyledIconButton from 'Components/Form/StyledIconButton'
import { CampaignHeaderNav } from 'Containers/Campaigns/Page/HeaderNav'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import { authorization } from 'Module/Auth/Auth'
import { SOURCE_OPPIZI_ADS } from '../../../constants'
import StyledBreadcrumbs from '../../../Components/StyledBreadcrumbs'

class CampaignPage extends Component {
  render() {
    const { campaign, campaignId, match } = this.props
    const { isSelfServe, bonusLimit } = campaign
    const isClientRole = authorization.isClientRole()
    const isCityManager = authorization.isCityManager()
    const isClientAdmin = authorization.isClientAdmin()
    const user = authorization.getUser()

    const campaignsRedirectURL = isClientRole
      ? `${PATHS.main.dashboard}${PATHS.dashboard.clientCampaigns}/${
          user.client.id
        }${PATHS.clientCampaignsDashboard.campaign}`
      : `${PATHS.main.dashboard}${PATHS.dashboard.campaigns}?Status=Active`

    const showBonusTab = bonusLimit && !(isClientRole || isClientAdmin)

    return (
      <CampaignPageWrapper>
        <LayoutDashboard className="campaign-main-info">
          <StyledBreadcrumbs
            icon={<CampaignsIcon style={{ width: 16 }} />}
            breadcrumbs={[
              {
                label: 'Campaigns',
                link: campaignsRedirectURL,
              },
              { label: campaign.name },
            ]}
          />
          <PageTitle>
            {campaign.name}{' '}
            {isCityManager && isSelfServe ? (
              <Chip label={SOURCE_OPPIZI_ADS} />
            ) : (
              ''
            )}
            {!isClientRole && (
              <Link
                style={{ float: 'right' }}
                to={`${PATHS.main.dashboard}${
                  PATHS.dashboard.campaigns
                }/${campaignId}${PATHS.campaign.edit}`}
                cypress_id="campaign-page-edit_campaign_button_link"
              >
                <StyledIconButton>
                  <EditIcon />
                </StyledIconButton>
              </Link>
            )}
          </PageTitle>
          <LogoRound logo={campaign.client ? campaign.client.logo : ''} />
        </LayoutDashboard>
        <CampaignHeaderNav
          active={this.props.active}
          campaignId={this.props.campaignId}
          match={match}
          history={this.props.history}
          showBonusTab={showBonusTab}
          campaign={campaign}
        />
        <HideWhenBlocked>{this.props.children}</HideWhenBlocked>
      </CampaignPageWrapper>
    )
  }
}

CampaignPage.propTypes = {
  campaign: PropTypes.object.isRequired,
}

const mapStateToProps = (state, props) => ({
  campaign: state.campaigns.campaigns[props.campaignId],
})

export default connect(mapStateToProps)(CampaignPage)
